<div class="page">
    <div class="container">
        <div class="row flex_top top_area row_jc_space_btw">
            <span class="skeleton_container" *ngIf="isUserLoading" style="width: 200px"><app-skeleton height="34"></app-skeleton>
            </span><h1 *ngIf="user.firstname || user.lastname" class="fz_title row title">Привет, <span *ngIf="user.firstname == '' && user.lastname == ''">незнакомец!</span> <span *ngIf="user.firstname !== '' || user.lastname !== ''">{{userFirstName}} {{userLastName}}!</span></h1>
            <a routerLink="/orders/create-orders" class="create_order btn dark_btn row fz_s fw_500 cursor_pointer">Создать заказ <span
                    class="material-symbols-outlined fz_m">
                    add
                </span></a>
        </div>
        <div class="main_content">
            <div class="row">
                <div class="col-14">
                    <div class="row flex_cards cards">
                        <app-summary-card *ngIf="revenue" class="col-8" title="Доход" dollar="$" [isLoading]="isRevenueLoading"
                            [currentValue]="revenue.currentRevenue" [previousValue]="revenue.lastRevenue" [percent]="revenue.percentageChange"
                            [dynamics]="getTrend(revenue.percentageChange)" days="7">
                        </app-summary-card>
                
                        <app-summary-card *ngIf="ordersCount" class="col-8" title="Заказы" [isLoading]="isOrdersLoading"
                            [currentValue]="ordersCount.currentOrders" [previousValue]="ordersCount.lastOrders" [percent]="ordersCount.percentageChange"
                            [dynamics]="getTrend(ordersCount.percentageChange)" days="7">
                        </app-summary-card>
                
                        <app-summary-card *ngIf="clientsCount" class="col-8" title="Клиенты" [isLoading]="isClientsLoading"
                            [currentValue]="clientsCount.currentCount" [previousValue]="clientsCount.previousCount" [percent]="clientsCount.percentageChange"
                            [dynamics]="getTrend(clientsCount.percentageChange)" days="7">
                        </app-summary-card>
                    </div>
                    <div class="cards">
                        <app-leads-card></app-leads-card>
                    </div>
                    <div class="cards">
                        <app-income-card title="Доход"></app-income-card>
                    </div>
                </div>
                <div class="col-10">
                    <div class="cards height_card">
                        <app-orders-card></app-orders-card>
                    </div>
                    <div class="cards height_card">
                        <app-expiring-account-card></app-expiring-account-card>
                    </div>
                </div>
            </div>
            <app-map-world></app-map-world>
    </div>
<app-toastr></app-toastr>
